import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';

export default function Projects() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  // Project images from public folder
  const projects = [
    { id: 1, image: '/pic1.jpeg' },
    { id: 2, image: '/pic2.jpeg' },
    { id: 3, image: '/pic3.jpeg' },
    { id: 4, image: '/pic4.jpeg' },
    { id: 5, image: '/pic5.jpeg' },
    { id: 6, image: '/pic6.jpeg' },
    { id: 7,  image: '/pic7.jpeg' },
    { id: 8, image: '/pic8.jpeg' },
    { id: 9, image: '/pic9.jpeg' },
    { id: 10, image: '/pic10.jpeg' },
    { id: 11, image: '/pic11.jpeg' },
    { id: 12, image: '/pic12.jpeg' },
    { id: 13, image: '/pic13.jpeg' },
    { id: 14, image: '/pic14.jpeg' },
    { id: 15, image: '/pic15.jpeg' },
    { id: 16, image: '/pic16.jpeg' },
    { id: 17, image: '/pic17.jpeg' },
    { id: 18, image: '/pic18.jpeg' },
    { id: 19, image: '/pic19.jpeg' },
    { id: 20, image: '/pic20.jpeg' },
    { id: 21, image: '/pic21.jpeg' },
    { id: 22, image: '/pic22.jpeg' },
    { id: 23, image: '/pic23.jpeg' },
    { id: 24, image: '/pic24.jpeg' },
    { id: 25, image: '/pic25.jpeg' },
    { id: 26, image: '/pic26.jpeg' },
    { id: 27, image: '/pic27.jpeg' },
    { id: 28, image: '/pic28.jpeg' },
  ];

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      transition: {
        delay: i * 0.1,
        duration: 0.4,
      },
    }),
  };

  return (
    <section id="projects" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-black mb-4">Our Work</h2>
          <p className="text-black text-lg max-w-2xl mx-auto">
            Stunning projects that showcase our expertise and dedication to excellence
          </p>
        </motion.div>

        

        {/* Masonry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-max">
          {projects.map((project, index) => (
            <motion.div
              key={project.id}
              custom={index}
              variants={imageVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="relative group cursor-pointer overflow-hidden rounded-lg min-h-48 max-h-80"
              onMouseEnter={() => setHoveredId(project.id)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={() => setSelectedImage(project)}
            >
              {/* Project Image */}
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />

              {/* Hover Overlay */}
              <motion.div
                className="absolute inset-0 bg-black bg-opacity-0 flex items-end justify-start p-6"
                animate={{
                  backgroundColor: hoveredId === project.id ? 'rgba(0,0,0,0.6)' : 'rgba(0,0,0,0)',
                }}
                transition={{ duration: 0.3 }}
              >
                <motion.div
                  animate={{
                    opacity: hoveredId === project.id ? 1 : 0,
                    y: hoveredId === project.id ? 0 : 20,
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <h3 className="text-white font-bold text-lg mb-1">{project.title}</h3>
                  <p className="text-gray-300 text-sm">{project.category}</p>
                  <button className="mt-3 inline-flex items-center gap-2 text-white bg-black px-4 py-2 rounded-lg font-semibold text-sm hover:bg-gray-800 transition-colors">
                    View Project →
                  </button>
                </motion.div>
              </motion.div>
            </motion.div>
          ))}

          {/* Add More Projects Card */}
      
        </div>

        {/* Lightbox Modal */}
        <AnimatePresence>
          {selectedImage && (
            <motion.div
              className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setSelectedImage(null)}
            >
              <motion.div
                className="relative max-w-4xl max-h-[90vh] w-full"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.9, opacity: 0 }}
                onClick={(e) => e.stopPropagation()}
              >
                {/* Project Image in Modal */}
                <img
                  src={selectedImage.image}
                  alt={selectedImage.title}
                  className="w-full h-80 object-cover rounded-lg"
                />

                {/* Close Button */}
                <motion.button
                  className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors"
                  onClick={() => setSelectedImage(null)}
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FiX size={32} />
                </motion.button>

                {/* Image Info */}
                <div className="mt-6 text-white text-center">
                  <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
                  <p className="text-gray-300">{selectedImage.category}</p>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}
